import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import SchemaOrg from '@/components/base/SchemaOrg';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.tuhaomanhua.com/' },
    { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://www.tuhaomanhua.com/about' },
  ],
};

const aboutSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于蜜桃少年漫画 - 土豪漫画网',
  description: '土豪漫画网旗下蜜桃少年漫画品牌介绍、口碑评价与联系方式。致力于为广大漫画爱好者提供优质的漫画全集下拉式免费阅读服务。',
  mainEntity: {
    '@type': 'Organization',
    name: '土豪漫画网',
    description: '专业中文漫画在线阅读平台，提供蜜桃少年漫画等海量漫画全集下拉式免费阅读服务。',
    url: 'https://www.tuhaomanhua.com/',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@tuhaomanhua.com',
    },
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '土豪漫画网的漫画资源是正版吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '土豪漫画网严格遵守版权法规，所有漫画内容均获得版权方授权或通过合法渠道获取，确保读者能够放心阅读。',
      },
    },
    {
      '@type': 'Question',
      name: '如何联系土豪漫画网的客服？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以通过发送邮件至 contact@tuhaomanhua.com 联系我们的客服团队，我们将在24小时内回复您的问题。',
      },
    },
    {
      '@type': 'Question',
      name: '土豪漫画网支持哪些设备阅读？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '土豪漫画网支持PC端、平板和手机浏览器访问，全平台自适应，让您随时随地享受下拉式漫画阅读的乐趣。',
      },
    },
    {
      '@type': 'Question',
      name: '蜜桃少年漫画什么时候更新？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '蜜桃少年漫画保持定期更新，通常每周更新1-2话新内容。具体更新时间请关注土豪漫画网首页的最新更新板块。',
      },
    },
  ],
};

const timeline = [
  { year: '2018', title: '创立之初', desc: '土豪漫画网正式上线，以提供高质量中文漫画为目标。' },
  { year: '2019', title: '快速发展', desc: '漫画库突破5000部，日活跃用户突破10万。' },
  { year: '2020', title: '蜜桃少年品牌诞生', desc: '推出蜜桃少年漫画品牌，专注于少年漫画领域的深耕。' },
  { year: '2021', title: '技术升级', desc: '全面升级阅读体验，推出下拉式流畅阅读模式。' },
  { year: '2022', title: '用户突破', desc: '注册用户突破500万，成为国内领先的漫画阅读平台之一。' },
  { year: '2023', title: '内容拓展', desc: '漫画库突破10000部，涵盖更多元化的漫画类型。' },
  { year: '2024', title: '品质飞跃', desc: '与多位知名漫画家达成合作，独家引进优质漫画作品。' },
  { year: '2025', title: '生态完善', desc: '构建完整的漫画阅读生态，为读者提供更优质的服务。' },
  { year: '2026', title: '持续创新', desc: '持续优化阅读体验，致力于成为最受喜爱的漫画阅读平台。' },
];

const testimonials = [
  {
    name: '漫画迷小王',
    role: '忠实读者 3年',
    content: '土豪漫画网是我用过最好的漫画阅读网站，蜜桃少年漫画的画风和剧情都超棒！下拉式阅读体验非常流畅，每天必刷。',
    rating: 5,
  },
  {
    name: '二次元少女',
    role: 'VIP读者 2年',
    content: '从大学开始就在土豪漫画网看漫画了，分类很全，更新也快。最爱的就是蜜桃少年系列，画风细腻，故事温暖人心。',
    rating: 5,
  },
  {
    name: '追漫达人老张',
    role: '漫画博主',
    content: '作为漫画博主，我向粉丝推荐最多的就是土豪漫画网。资源丰富、阅读流畅、更新及时，是漫画爱好者的首选平台。',
    rating: 5,
  },
  {
    name: '小明的漫画日记',
    role: '资深读者 4年',
    content: '土豪漫画网的少年漫画专区做得特别棒，分类清晰，推荐精准。蜜桃少年漫画更是我的心头好，每次更新都第一时间追。',
    rating: 4,
  },
];

export default function AboutPage() {
  return (
    <>
      <SchemaOrg data={breadcrumbSchema} />
      <SchemaOrg data={aboutSchema} />
      <SchemaOrg data={faqSchema} />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="max-w-[1200px] mx-auto px-4 md:px-6 lg:px-8 pt-24 pb-14">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          {/* Hero */}
          <section className="text-center mb-14">
            <h1 className="text-3xl md:text-4xl font-heading text-foreground-900 mb-4">
              关于蜜桃少年漫画
            </h1>
            <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
              土豪漫画网旗下专业少年漫画阅读品牌，致力于为广大漫画爱好者提供优质的漫画全集下拉式免费阅读服务。我们相信，好的漫画可以温暖人心，激发想象，陪伴成长。
            </p>
          </section>

          {/* Brand Story */}
          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-2 text-center">品牌故事</h2>
            <p className="text-sm text-foreground-500 text-center mb-8">一路走来，感谢有你</p>

            {/* Timeline */}
            <div className="relative">
              <div className="absolute left-1/2 top-0 bottom-0 w-px bg-background-200/70 hidden md:block"></div>
              <div className="space-y-6">
                {timeline.map((item, index) => (
                  <div key={item.year} className={`flex flex-col md:flex-row items-center gap-4 ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                    <div className={`flex-1 ${index % 2 === 0 ? 'md:text-right' : 'md:text-left'} hidden md:block`}>
                      <div className="p-4 rounded-lg bg-background-100">
                        <h4 className="font-semibold text-foreground-900 text-sm">{item.title}</h4>
                        <p className="text-xs text-foreground-500 mt-1">{item.desc}</p>
                      </div>
                    </div>
                    <div className="flex-shrink-0 z-10">
                      <div className="w-14 h-14 rounded-full bg-primary-500 text-white flex items-center justify-center font-heading text-sm">
                        {item.year}
                      </div>
                    </div>
                    <div className="flex-1 md:hidden">
                      <div className="p-4 rounded-lg bg-background-100">
                        <h4 className="font-semibold text-foreground-900 text-sm">{item.title}</h4>
                        <p className="text-xs text-foreground-500 mt-1">{item.desc}</p>
                      </div>
                    </div>
                    <div className={`flex-1 ${index % 2 === 0 ? '' : ''} hidden md:block`}>
                      {index % 2 === 1 && (
                        <div className="p-4 rounded-lg bg-background-100">
                          <h4 className="font-semibold text-foreground-900 text-sm">{item.title}</h4>
                          <p className="text-xs text-foreground-500 mt-1">{item.desc}</p>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Testimonials */}
          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-2 text-center">读者口碑</h2>
            <p className="text-sm text-foreground-500 text-center mb-8">来自读者的真实评价</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
              {testimonials.map((t, index) => (
                <div key={index} className="p-5 rounded-lg bg-background-100">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: t.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">{t.content}</p>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                      <span className="text-primary-600 text-sm font-heading">{t.name[0]}</span>
                    </div>
                    <div>
                      <div className="font-semibold text-foreground-900 text-sm">{t.name}</div>
                      <div className="text-xs text-foreground-500">{t.role}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Contact Info */}
          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-2 text-center">联系我们</h2>
            <p className="text-sm text-foreground-500 text-center mb-8">有任何问题或建议？欢迎联系我们</p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
              <div className="p-5 rounded-lg bg-background-100 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-line text-primary-600 text-xl"></i>
                </div>
                <h4 className="font-semibold text-foreground-900 text-sm mb-1">电子邮箱</h4>
                <p className="text-xs text-foreground-500">contact@tuhaomanhua.com</p>
              </div>
              <div className="p-5 rounded-lg bg-background-100 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-map-pin-line text-accent-600 text-xl"></i>
                </div>
                <h4 className="font-semibold text-foreground-900 text-sm mb-1">公司地址</h4>
                <p className="text-xs text-foreground-500">北京市朝阳区漫画大厦</p>
              </div>
              <div className="p-5 rounded-lg bg-background-100 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-customer-service-2-line text-secondary-600 text-xl"></i>
                </div>
                <h4 className="font-semibold text-foreground-900 text-sm mb-1">商务合作</h4>
                <p className="text-xs text-foreground-500">business@tuhaomanhua.com</p>
              </div>
            </div>
          </section>

          {/* FAQ */}
          <section>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-2 text-center">常见问题</h2>
            <p className="text-sm text-foreground-500 text-center mb-8">快速解答您的疑问</p>
            <div className="max-w-[800px] mx-auto space-y-3">
              {faqSchema.mainEntity.map((faq, index) => (
                <details key={index} className="group bg-background-100 rounded-lg overflow-hidden">
                  <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer hover:bg-background-200/70 transition-colors list-none">
                    <h3 className="text-sm font-semibold text-foreground-900 pr-4">{faq.name}</h3>
                    <span className="flex-shrink-0 w-6 h-6 rounded-full bg-accent-100 flex items-center justify-center group-open:rotate-45 transition-transform">
                      <i className="ri-add-line text-accent-600 text-sm"></i>
                    </span>
                  </summary>
                  <div className="px-4 md:px-5 pb-4 md:pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.acceptedAnswer.text}</p>
                  </div>
                </details>
              ))}
            </div>
          </section>

          {/* CTA */}
          <section className="mt-14 text-center p-8 md:p-10 rounded-lg bg-accent-100">
            <h2 className="text-xl font-heading text-foreground-900 mb-2">
              加入蜜桃少年漫画的大家庭
            </h2>
            <p className="text-sm text-foreground-600 mb-5 max-w-lg mx-auto">
              立即开始阅读，发现属于你的精彩漫画世界
            </p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-full font-semibold text-sm transition-all whitespace-nowrap"
            >
              返回首页 <i className="ri-arrow-right-line"></i>
            </Link>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}